const VIPRedemptionMethod = {
  LOCQPay: "locqpay",
  Cash: "cash",
};

export default VIPRedemptionMethod;
